import dayjs from "dayjs"
import { getUserFullName } from "../../../helpers/userDisplay"

export const getRoleInitials = name =>
  (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .map(part => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase()

export const countPermissionsGranted = permissions => {
  if (Array.isArray(permissions)) {
    return permissions.length
  }
  return Object.values(permissions || {}).filter(
    level => level && level !== "none",
  ).length
}

const formatUserName = user => getUserFullName(user, { fallback: "--" })

const formatUserCity = user => {
  const city =
    user?.city?.name ||
    user?.city_name ||
    user?.address?.city?.name ||
    user?.city ||
    ""
  const country =
    user?.country ||
    user?.address?.city?.country ||
    user?.city?.country ||
    ""
  if (city && country) return `${city}, ${country}`
  return city || country || "--"
}

const formatUserStatus = user => {
  if (typeof user?.is_active === "boolean") {
    return user.is_active ? "active" : "inactive"
  }
  const raw = String(user?.status || "active").toLowerCase()
  return raw === "inactive" ? "inactive" : "active"
}

export const mapAssignedUsers = (users = []) =>
  (Array.isArray(users) ? users : []).map(user => {
    const assignedRaw =
      user.assigned_at || user.created_at || user.pivot?.created_at || ""
    return {
      id: user.id,
      name: formatUserName(user),
      city: formatUserCity(user),
      status: formatUserStatus(user),
      assignedDate: assignedRaw
        ? dayjs(assignedRaw).format("MMM D, YYYY")
        : "--",
      memberId: user.id,
    }
  })

/**
 * Map GET /api/v1/admin/roles/get-single/:id → Role Detail view model.
 */
export const mapAdminRoleDetail = result => {
  if (!result?.id) return null

  const apiPermissions = Array.isArray(result.permissions)
    ? result.permissions
    : []
  const stats = result.stats || {}
  const usersAssigned = Number(
    stats.users_assigned ??
      (Array.isArray(result.users) ? result.users.length : 0),
  )
  const permissionsGranted = Number(
    stats.permissions_granted ?? apiPermissions.length,
  )
  const isActive =
    typeof result.is_active === "boolean"
      ? result.is_active
      : result.status !== "inactive"

  return {
    id: result.id,
    name: result.name || "--",
    description: result.description || "--",
    status: isActive ? "active" : "inactive",
    users: Number.isFinite(usersAssigned) ? usersAssigned : 0,
    permissionsGranted: Number.isFinite(permissionsGranted)
      ? permissionsGranted
      : 0,
    permissionIds: apiPermissions.map(p => p.id).filter(Boolean),
    permissionList: apiPermissions,
    assignedUsers: mapAssignedUsers(result.users),
    lastUpdatedDisplay: result.updated_at
      ? dayjs(result.updated_at).format("MMM D, YYYY")
      : "--",
    raw: result,
  }
}
